<div class="psdk-one-column-tab">
  <app-one-column [formGroup$]="formGroup$" [pConn$]="pConn$"></app-one-column>
</div>